import { createContext, type PropsWithChildren } from "react";

interface ChromeContextDescriptor {
  isSidebarExpanded: boolean;
}

export const ChromeContext = createContext<ChromeContextDescriptor | null>(
  null,
);

export const ChromeProvider = ({
  isSidebarExpanded,
  children,
}: PropsWithChildren<ChromeContextDescriptor>) => {
  return (
    <ChromeContext.Provider
      value={{
        isSidebarExpanded,
      }}
    >
      {children}
    </ChromeContext.Provider>
  );
};
